// export const domain = "http://176.58.97.42/";
export const domain = "https://zain-sim-swap.talabatey.com/";
export const baseurl = `${domain}`;
export const INVALID_UUID = "value is not a valid uuid";
export const INVALID_HOUR = "Unprocessable Entity";
export const INVALID_LOCATION = [
    "Not a tawseel loop",
    "Location not covered",
    "No matching location"
];


function StepObject(label, order) {
    this.label = label;
    this.order = order
}

function Language(code, displayName) {
    this.code = code;
    this.displayName = displayName;
}

export const availableLangs = [
    new Language("en", "English"),
    new Language("ar", "العربية"),
    new Language("ku", "كوردي"),
];
export const steps = [
    new StepObject("codeVerification", 1),
    new StepObject("choseLocation", 2),
    new StepObject("determineTime", 3),
    new StepObject("track", 4),
];
export const daysMap = {
    "Mon": 1,
    "Tue": 2,
    "Wed": 3,
    "Thu": 4,
    "Fri": 5,
    "Sat": 6,
    "Sun": 7
};

export const mapCenter = [33.3152, 44.3661];

export const zoom = 6;

export let stateObject = {
    location: 0,
    street: "",
    expected_date: "",
    expected_time: "",
    building: "",
    apartment: "",
    reference_point: "",
    driver_assigned: null,
    driver_location: null,
    tracking: null,
    driver_on_way: false,
    district: "",
    driver_mobile: "",
    city_id: null,
    district_id: null,
    accepted: null,
        location_auto_detected: false
    // schedule: null
}

